/*
 * pbf-search — premium zoeken voor Plants by Frank.
 * De input is de navbar-pill (desktop); de resultaten verschijnen als dropdown
 * die uit de pill schuift. Mobiel: icoon opent een paneel met eigen input.
 * Bouwt op Shopify's native predictive search (currency/Markets-veilig).
 *
 * State: exact één waarheid (this.isOpen), alleen gewijzigd door open()/close().
 */
(function () {
  if (customElements.get('pbf-search')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SUGGEST_URL = ROOT.replace(/\/$/, '') + '/search/suggest';
  var MQ_DESKTOP = window.matchMedia('(min-width: 990px)');

  class PbfSearch extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.boot.bind(this), { once: true });
      } else {
        this.boot();
      }
    }

    boot() {
      if (this._ready) return;
      this._ready = true;

      // Naar <body> zodat position:fixed nooit door een header-stacking-context wordt beperkt.
      if (this.parentElement !== document.body) document.body.appendChild(this);

      this.panel = this.querySelector('[data-pbf-search-panel]');
      this.backdrop = this.querySelector('[data-pbf-search-backdrop]');
      this.results = this.querySelector('[data-pbf-search-results]');
      this.empty = this.querySelector('[data-pbf-search-empty]');
      this.live = this.querySelector('[data-pbf-search-live]');
      this.panelInput = this.querySelector('[data-pbf-search-input]');
      this.panelForm = this.panel ? this.panel.querySelector('[data-pbf-search-form]') : null;

      this.desktopForm = document.querySelector('[data-pbf-search-desktop]');
      this.desktopInput = this.desktopForm ? this.desktopForm.querySelector('[data-pbf-search-input]') : null;
      this.header = document.querySelector('.header-wrapper') || document.querySelector('.pbf-header-main');
      this.triggers = Array.prototype.slice.call(document.querySelectorAll('[data-pbf-search-open]'));

      this.minChars = 2;
      this.debounceMs = 200;
      this.timer = null;
      this.controller = null;
      this.activeIndex = -1;
      this.isOpen = false;
      this.locked = false;
      this.currentInput = this.desktopInput || this.panelInput;

      var self = this;

      this.inputs = [this.desktopInput, this.panelInput].filter(Boolean);
      this.inputs.forEach(function (inp) {
        inp.addEventListener('input', function (e) { self.onInput(e); });
        inp.addEventListener('keydown', function (e) { self.onInputKeydown(e); });
        inp.addEventListener('focus', function () {
          self.currentInput = inp;
          if (inp === self.desktopInput) self.open();
        });
      });

      [this.desktopForm, this.panelForm].filter(Boolean).forEach(function (f) {
        f.addEventListener('submit', function (e) { self.onSubmit(e); });
      });

      [this.desktopForm, this.panel].filter(Boolean).forEach(function (scope) {
        var b = scope.querySelector('[data-pbf-search-clear]');
        if (b) b.addEventListener('click', function () { self.clear(); });
      });

      this.triggers.forEach(function (t) {
        t.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
      });
      this.querySelectorAll('[data-pbf-search-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });

      // Klik op een resultaat/chip: laat navigeren, sluit netjes.
      [this.results, this.empty].filter(Boolean).forEach(function (scope) {
        scope.addEventListener('click', function (e) {
          if (e.target.closest('[data-pbf-ps-result]')) self.close();
        });
      });

      // Persistente globale listeners met guards (geen add/remove-gedoe).
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) {
          self.close();
          if (self.currentInput) self.currentInput.blur();
          return;
        }
        var k = (e.key || '').toLowerCase();
        if ((e.metaKey || e.ctrlKey) && k === 'k') { e.preventDefault(); self.isOpen ? self.close() : self.open(); return; }
        if (e.key === '/' && !self.isOpen && !self.isTyping(e.target)) { e.preventDefault(); self.open(); }
      });

      // Buiten-klik sluit (pointerdown capture = snappy). Backdrop telt als buiten.
      // DESKTOP: klik buiten de dropdown sluit (snappy via pointerdown).
      // MOBIEL: NIET via document-pointerdown — dat gaat af op naloop-events van de
      // openende tap + het opkomende toetsenbord, waardoor het paneel meteen sloot.
      // Mobiel sluit via een echte tap op de backdrop (hieronder) of de sluitknop.
      document.addEventListener('pointerdown', function (e) {
        if (!self.isOpen || !self.isDesktop()) return;
        if (Date.now() - (self._openAt || 0) < 300) return;
        var t = e.target;
        if (self.panel && self.panel.contains(t)) return;
        if (t.closest && (t.closest('[data-pbf-search-desktop]') || t.closest('[data-pbf-search-open]'))) return;
        self.close();
      }, true);

      // Mobiel (en desktop): een klik op de dim-backdrop buiten het paneel sluit.
      if (this.backdrop) {
        this.backdrop.addEventListener('click', function () {
          if (Date.now() - (self._openAt || 0) < 300) return;
          self.close();
        });
      }

      // Desktop-dropdown zit vast aan de pill: sluit bij scrollen, herposition bij resize.
      window.addEventListener('scroll', function () {
        if (self.isOpen && self.isDesktop()) self.close();
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (!self.isOpen) return;
        if (self.isDesktop()) { self.position(); return; }
        // Mobiel: NIET sluiten bij resize — het mobiele toetsenbord triggert een
        // resize zodra de input focus krijgt. Alleen sluiten als we uit de
        // desktop-modus komen (paneel nog 'is-anchored' maar nu mobiele breedte).
        if (self.classList.contains('is-anchored')) self.close();
      });
      window.addEventListener('pageshow', function () { self.close(); });

      this.syncEmptyState();
    }

    isDesktop() { return MQ_DESKTOP.matches && !!this.desktopForm; }
    isTyping(el) {
      if (!el) return false;
      var t = el.tagName;
      return el.isContentEditable || t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT';
    }

    // ---- state ----
    open() {
      if (this.isOpen) { this.position(); return; }
      this.isOpen = true;
      this._openAt = Date.now();
      this.position();
      this.setAttribute('open', '');
      this.triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      if (this.desktopForm) this.desktopForm.setAttribute('aria-expanded', 'true');
      // Scroll-lock alléén als modal (mobiel). Desktop-dropdown niet locken.
      this.lock(!this.isDesktop());
      var focusEl = this.isDesktop() ? this.desktopInput : this.panelInput;
      this.currentInput = focusEl;
      requestAnimationFrame(function () {
        if (focusEl && document.activeElement !== focusEl) focusEl.focus();
      });
      this.syncEmptyState();
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.removeAttribute('open');
      this.lock(false);
      this.triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      if (this.desktopForm) this.desktopForm.setAttribute('aria-expanded', 'false');
      this.activeIndex = -1;
      if (this.controller) this.controller.abort();
      clearTimeout(this.timer);
      this.removeAttribute('loading');
    }

    lock(on) {
      if (on === this.locked) return;
      this.locked = on;
      document.documentElement.classList.toggle('pbf-search-lock', on);
    }

    position() {
      if (this.isDesktop()) {
        var r = this.desktopForm.getBoundingClientRect();
        var vw = document.documentElement.clientWidth;
        var w = Math.max(r.width, 460);
        var left = r.left;
        if (left + w > vw - 12) left = Math.max(12, vw - 12 - w);
        this.style.setProperty('--pbf-anchor-top', (r.bottom + 10) + 'px');
        this.style.setProperty('--pbf-anchor-left', left + 'px');
        this.style.setProperty('--pbf-anchor-width', w + 'px');
        this.classList.add('is-anchored');
      } else {
        var hb = this.header ? this.header.getBoundingClientRect().bottom : 84;
        this.style.setProperty('--pbf-anchor-top', Math.max(hb, 0) + 'px');
        this.classList.remove('is-anchored');
      }
    }

    // ---- zoeken ----
    clear() {
      if (this.currentInput) { this.currentInput.value = ''; this.currentInput.focus(); }
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      this.removeAttribute('loading');
      if (this.results) this.results.innerHTML = '';
      this.updateClear();
      this.syncEmptyState();
    }

    updateClear() {
      [this.desktopForm, this.panel].filter(Boolean).forEach(function (scope) {
        var inp = scope.querySelector('[data-pbf-search-input]');
        var btn = scope.querySelector('[data-pbf-search-clear]');
        if (inp && btn) btn.hidden = !(inp.value.length > 0);
      });
    }

    syncEmptyState() {
      var q = this.currentInput ? this.currentInput.value.trim() : '';
      var showEmpty = q.length < this.minChars;
      if (this.empty) this.empty.hidden = !showEmpty;
      if (this.results) this.results.hidden = showEmpty;
      this.updateClear();
    }

    onInput(e) {
      this.currentInput = e.target;
      if (!this.isOpen) this.open();
      this.updateClear();
      var q = e.target.value.trim();
      clearTimeout(this.timer);
      if (q.length < this.minChars) {
        if (this.controller) this.controller.abort();
        this.removeAttribute('loading');
        this.syncEmptyState();
        return;
      }
      if (this.empty) this.empty.hidden = true;
      if (this.results) this.results.hidden = false;
      this.setAttribute('loading', '');
      var self = this;
      this.timer = setTimeout(function () { self.fetchResults(q); }, this.debounceMs);
    }

    fetchResults(q) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var params = new URLSearchParams({ q: q, section_id: 'pbf-predictive-search' });
      params.append('resources[type]', 'product,collection,article,page,query');
      params.append('resources[limit]', '6');
      params.append('resources[options][unavailable_products]', 'last');

      var self = this;
      fetch(SUGGEST_URL + '?' + params.toString(), { signal: this.controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section =
            doc.querySelector('#shopify-section-pbf-predictive-search') ||
            doc.querySelector('.shopify-section') || doc.body;
          if (self.results) self.results.innerHTML = section ? section.innerHTML : '';
          self.removeAttribute('loading');
          self.activeIndex = -1;
          self.announce();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          self.removeAttribute('loading');
        });
    }

    // ---- toetsenbord ----
    resultEls() {
      return Array.prototype.slice.call(this.querySelectorAll('[data-pbf-ps-result]'))
        .filter(function (el) { return el.offsetParent !== null; });
    }

    onInputKeydown(e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); this.move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.move(-1); }
      else if (e.key === 'Enter') {
        var items = this.resultEls();
        if (this.activeIndex >= 0 && items[this.activeIndex]) {
          e.preventDefault();
          this.close();
          items[this.activeIndex].click();
        }
      }
    }

    move(dir) {
      var items = this.resultEls();
      if (!items.length) return;
      items.forEach(function (i) { i.classList.remove('is-active'); i.setAttribute('aria-selected', 'false'); });
      this.activeIndex = (this.activeIndex + dir + items.length) % items.length;
      var el = items[this.activeIndex];
      el.classList.add('is-active');
      el.setAttribute('aria-selected', 'true');
      el.scrollIntoView({ block: 'nearest' });
    }

    onSubmit(e) {
      var inp = e.currentTarget.querySelector('[data-pbf-search-input]');
      if (!inp || !inp.value.trim()) { e.preventDefault(); return; }
      this.close();
    }

    announce() {
      if (!this.live) return;
      var countEl = this.querySelector('[data-pbf-ps-count]');
      var n = countEl ? parseInt(countEl.textContent, 10) : this.resultEls().length;
      this.live.textContent = n > 0 ? (n + ' resultaten gevonden') : 'Geen resultaten';
    }
  }

  customElements.define('pbf-search', PbfSearch);
})();
